import { Parts_parts_data } from "../shared/gql/__generated__/Parts"
import { BikeParts_bikeParts_data_attributes_part_data } from "../pages/BikeParts/gql/__generated__/BikeParts"
import {
  UserBikes_bikes_data_attributes_bike_parts_data_attributes_part_data
} from "../shared/gql/__generated__/UserBikes"

const extractTitle = (part: Parts_parts_data | BikeParts_bikeParts_data_attributes_part_data | UserBikes_bikes_data_attributes_bike_parts_data_attributes_part_data) => (part?.attributes?.name ?? "") + " " + (part?.attributes?.brand?.data?.attributes?.name ?? "") + " " + (part?.attributes?.category?.data?.attributes?.name ?? "")

export default extractTitle
